export default __webpack_public_path__ + "static/logo-bert-dark-9e30f76e215b067185c590f015357d9f.svg";